const formControlLabelFormCreateUser = {
  admin: 'Administrador',
  analyst: 'Analista',
  contractor: 'Tercera empresa'
};

export default formControlLabelFormCreateUser;
